export default {
  CONFLICT: 409,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
};
